module.exports = __webpack_public_path__ + "img/EG.d89ba362.svg";